import { useQuery } from "@apollo/client/react";
import TREAT_DAILY_SUMMARIES_QUERY from "@graphql/queries/TreatDailySummaries";

export type TreatDailySummary = {
  date: string;
  netChange: number;
  treatsCredited: number;
  treatsUsed: number;
};

function resolveDeviceTimezone(): string | undefined {
  try {
    return (
      Intl.DateTimeFormat().resolvedOptions().timeZone || undefined
    );
  } catch {
    return undefined;
  }
}

const DEVICE_TIMEZONE = resolveDeviceTimezone();

export function useTreatDailySummaries({
  days = 30,
}: { days?: number } = {}) {
  const { data, loading, error, refetch } = useQuery(
    TREAT_DAILY_SUMMARIES_QUERY,
    {
      variables: { days, timezone: DEVICE_TIMEZONE },
      fetchPolicy: "cache-and-network",
    },
  );

  const summaries = (data?.treatDailySummaries ??
    []) as TreatDailySummary[];

  return { summaries, loading, error, refetch };
}
